import { apiService } from './api';

const AUTO_INCREMENT_BASE_URL = '/auto-increment';

const autoIncrementService = {
  // Get all auto increment sequences
  getAllSequences: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = queryParams ? `${AUTO_INCREMENT_BASE_URL}?${queryParams}` : AUTO_INCREMENT_BASE_URL;
      console.log('Fetching auto increment sequences with URL:', url);
      const response = await apiService.get(url);
      console.log('Received response:', response.data?.data?.length || 0, 'sequences');
      return response.data;
    } catch (error) {
      console.error('Error fetching auto increment sequences:', error);
      throw error;
    }
  },

  // Get single auto increment sequence
  getSequenceById: async (id) => {
    try {
      const response = await apiService.get(`${AUTO_INCREMENT_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching auto increment sequence:', error);
      throw error;
    }
  },

  // Create new auto increment sequence
  createSequence: async (sequenceData) => {
    try {
      const response = await apiService.post(AUTO_INCREMENT_BASE_URL, sequenceData);
      return response.data;
    } catch (error) {
      console.error('Error creating auto increment sequence:', error);
      throw error;
    }
  },

  // Update auto increment sequence
  updateSequence: async (id, sequenceData) => {
    try {
      const response = await apiService.put(`${AUTO_INCREMENT_BASE_URL}/${id}`, sequenceData);
      return response.data;
    } catch (error) {
      console.error('Error updating auto increment sequence:', error);
      throw error;
    }
  },

  // Delete auto increment sequence
  deleteSequence: async (id) => {
    try {
      const response = await apiService.delete(`${AUTO_INCREMENT_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting auto increment sequence:', error);
      throw error;
    }
  },

  // Get next value for a sequence (increments the value)
  getNextValue: async (sequenceName) => {
    try {
      const response = await apiService.get(`${AUTO_INCREMENT_BASE_URL}/next/${sequenceName}`);
      return response.data;
    } catch (error) {
      console.error('Error getting next value:', error);
      throw error;
    }
  },

  // Get current value for a sequence (without incrementing)
  getCurrentValue: async (sequenceName) => {
    try {
      const response = await apiService.get(`${AUTO_INCREMENT_BASE_URL}/current/${sequenceName}`);
      return response.data;
    } catch (error) {
      console.error('Error getting current value:', error);
      throw error;
    }
  },

  // Get sequence statistics
  getSequenceStats: async () => {
    try {
      const response = await apiService.get(`${AUTO_INCREMENT_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sequence statistics:', error);
      throw error;
    }
  }
};

export default autoIncrementService;
